import React from 'react';
import './ClientChallenges.css';

const challenges = [
  'Unclear strategy and scattered priorities',
  'Inefficient operations and broken processes',
  'Missed market expansion opportunities',
  'Weak brand positioning in the market',
  'Slow, reactive decision-making processes',
  'Lack of clear long-term strategic direction',
];

const solutions = [
  'Comprehensive business diagnostics and strategic clarity workshops',
  'Six Sigma process optimization and operational redesign',
  'Market entry strategies for India, ME, and Africa',
  'Brand repositioning and competitive differentiation',
  'Decision frameworks and leadership development programs',
  '12–60 month strategic roadmaps with measurable milestones',
];

const ClientChallenges = () => (
  <section id="chlg">
    <div className="w chlg-inner">
      <div className="rv">
        <div className="eye">Sound Familiar?</div>
        <h2 className="sh">Common Client <span>Challenges</span></h2>
      </div>
      <div className="chsp">
        <div className="rv d1">
          {challenges.map((challenge) => (
            <div className="chit" key={challenge}>
              <div className="chx">✕</div>
              <div className="chtx">{challenge}</div>
            </div>
          ))}
        </div>
        <div className="chsl rv d2">
          <div className="chslh">How StratX Solves This</div>
          <div className="chsls">Our structured engagements directly address each of these challenges.</div>
          {solutions.map((solution) => (
            <div className="chsli" key={solution}>
              <div className="chck">✓</div>
              <div className="chslt">{solution}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ClientChallenges;
